class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header') || document.querySelector('header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-notification__close')
  .forEach((closeButton) =>
    closeButton.addEventListener('click', this.close.bind(this))
  );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

renderContents(parsedState) {
  this.getSectionsToRender().forEach((section) => {
    const el = document.getElementById(section.id);
    if (!el) return;

    el.innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });

  this.open();

  setTimeout(() => {
  this.updateFreeShipping(parsedState);
}, 100);
  }

updateFreeShipping(parsedState) {
  const wrapper = document.querySelector('.dansoria-free-shipping');
  if (!wrapper) return;

  const FREE_LIMIT = 1500;
  fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {

    const subtotal = cart.items_subtotal_price / 100;

    const remaining = Math.max(0, FREE_LIMIT - subtotal);
    const progress = Math.min((subtotal / FREE_LIMIT) * 100, 100);

    if (remaining > 0) {
      wrapper.innerHTML = `
        <p class="fsp-text">
          🚚 Îți mai lipsesc <strong>${Math.round(remaining)} lei</strong>
          până la livrare gratuită.
        </p>

        <div class="fsp-bar">
          <div class="fsp-fill" style="width:${progress}%"></div>
        </div>
      `;
    } else {
      wrapper.innerHTML = `
        <p class="fsp-text success">
          🎉 Felicitări! Ai obținut livrare gratuită.
        </p>

        <div class="fsp-bar">
          <div class="fsp-fill" style="width:100%"></div>
        </div>
      `;
    }

  });

  const remaining = Math.max(0, FREE_LIMIT - subtotal);
  const progress = Math.min((subtotal / FREE_LIMIT) * 100, 100);

  if (remaining > 0) {
    wrapper.innerHTML = `
  <p class="fsp-text">
    🚚 Îți mai lipsesc <strong>${Math.round(remaining)} lei</strong>
    până la livrare gratuită.
  </p>

  <div class="fsp-bar">
    <div class="fsp-fill" style="width:${progress}%"></div>
  </div>
`;
  } else {
    wrapper.innerHTML = `
      <p class="fsp-text success">
        🎉 Felicitări! Ai obținut livrare gratuită.
      </p>

      <div class="fsp-bar">
        <div class="fsp-fill" style="width:100%"></div>
      </div>
    `;
  }
}

getSectionsToRender() {
  return [
    {
      id: 'cart-notification-product',
      selector: '.shopify-section',
    },
    {
      id: 'cart-icon-bubble',
      selector: '.shopify-section',
    }
  ];
}

getSectionInnerHTML(html, selector = '.shopify-section') {
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const el = parsed.querySelector(selector);

  if (!el) {
    console.error('Selector NOT FOUND:', selector);
    return '';
  }

  return el.innerHTML;
}

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-notification', CartNotification);